import { Link } from "@tanstack/solid-router";
import { For, Show } from "solid-js";

import { useAccounts } from "~/lib/hooks";

type Props = {
  wsKey: () => string;
  accountId: () => string;
};

export function AccountSubsidiariesCard(props: Props) {
  const subs = useAccounts(props.wsKey, () => ({
    parent_account_id: props.accountId(),
    limit: 50,
  }));

  return (
    <div class="card bg-base-100 shadow-sm">
      <div class="card-body">
        <h3 class="card-title text-lg">Subsidiaries</h3>

        <Show when={subs.isLoading}>
          <div role="status" class="py-4 text-center opacity-60 text-sm">
            Loading…
          </div>
        </Show>
        <Show when={subs.isError}>
          <div role="alert" class="alert alert-error text-sm">
            Failed to load subsidiaries.
          </div>
        </Show>
        <Show when={subs.data}>
          {(data) => (
            <Show
              when={data().items.length > 0}
              fallback={
                <div class="text-center py-6 opacity-60 text-sm">
                  No subsidiary accounts. Link one by setting its{" "}
                  <em>Parent account</em> to this one.
                </div>
              }
            >
              <ul class="divide-y divide-base-300">
                <For each={data().items}>
                  {(a) => (
                    <li class="py-2 flex items-center justify-between gap-2">
                      <div class="min-w-0">
                        <Link
                          to="/workspaces/$wsKey/accounts/$accId"
                          params={{ wsKey: props.wsKey(), accId: a.id }}
                          class="link link-primary font-medium"
                        >
                          {a.name}
                        </Link>
                        <div class="text-xs opacity-60 truncate">
                          {[a.primary_domain, a.lifecycle_stage]
                            .filter(Boolean)
                            .join(" · ") || "—"}
                        </div>
                      </div>
                      <span class="badge badge-ghost badge-sm">{a.kind}</span>
                    </li>
                  )}
                </For>
              </ul>
            </Show>
          )}
        </Show>
      </div>
    </div>
  );
}
